module.exports = __webpack_public_path__ + "img/loginbtn-google.ed03394.png";